import {
  LatestPromotion,
  PagedPromotion,
  PagedResult,
  Promotion,
  Result,
} from "@models";
import requests from "./agent";

export const promotionService = {
  getAll: async (tenantId: number) => {
    const response = await requests.get<Result<Promotion[]>>(
      "/api/Promotion/GetAll",
      { params: { tenantId } },
    );
    return response.result;
  },

  // Home teaser — the latest N active promotions (same endpoint as the page).
  getLatest: async (count = 6) => {
    const response = await requests.get<Result<PagedResult<LatestPromotion>>>(
      "/api/Promotion/GetActive",
      { params: { skipCount: 0, maxResultCount: count } },
    );
    return response.result.items;
  },

  getActive: async (request: PagedPromotion) => {
    const response = await requests.get<Result<PagedResult<LatestPromotion>>>(
      "/api/Promotion/GetActive",
      { params: request },
    );
    return response.result;
  },
};
